import React, { useState, useEffect } from 'react';
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Routes from "./components/Routes";
import ElevatorAnimation from "./components/animations/ElevatorAnimation";
import MobileElevatorAnimation from "./components/animations/MobileElevatorAnimation";

const App = () => {
  const [animationComplete, setAnimationComplete] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile screen size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 820);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Handle animation completion
  const handleAnimationComplete = () => {
    setAnimationComplete(true);

    // Add a small delay before showing content for a smoother transition
    setTimeout(() => {
      setShowContent(true);
    }, 500);
  };
  
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#0a0f1e",
        minHeight: "100vh",
        position: "relative",
        // overflow: "hidden"
      }}
    >
      {showContent && (
        <>
          <Header />
          <main style={{ 
            flex: 1, 
            padding: 0, 
            margin: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}>
            <Routes />
          </main>
          <Footer />
        </>
      )}
      
      {!showContent && (
        isMobile ? (
          <MobileElevatorAnimation onAnimationComplete={handleAnimationComplete} />
        ) : (
          <ElevatorAnimation onAnimationComplete={handleAnimationComplete} />
        )
      )}
    </div>
  );
};

export default App;